import { Drawer, DrawerProps } from 'antd';
import { useTheme } from 'styled-components';

import { Icon } from '@desygner/ui-common-components';

import { StyledCloseIconContainer, StyledCloseIconWrapper, getStyles } from './BottomSheet.style';

const PRESETS = {
  maxHeightPercentage: 95,
};

export default function BottomSheet({
  children,
  open,
  onClose,
  footer,
  title,
  keyboard,
  maskClosable,
  hasCloseBar = false,
  className,
  afterOpenChange,
}: DrawerProps & { hasCloseBar?: boolean }) {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Drawer
      placement="bottom"
      open={open}
      onClose={onClose}
      footer={footer}
      title={title}
      styles={{ ...styles.drawer }}
      closeIcon={null}
      height={hasCloseBar ? `${PRESETS.maxHeightPercentage}%` : 'auto'}
      destroyOnHidden
      rootClassName={className}
      keyboard={keyboard}
      maskClosable={maskClosable}
      afterOpenChange={afterOpenChange}
    >
      {hasCloseBar && (
        <StyledCloseIconWrapper>
          <StyledCloseIconContainer>
            <Icon name="cross" color={theme.Color.NeutralsFixed.Paper} onClick={onClose} />
          </StyledCloseIconContainer>
        </StyledCloseIconWrapper>
      )}
      {children}
    </Drawer>
  );
}
